export default __webpack_public_path__ + "static/media/33.ed6a450f.png";